import React from 'react'
import { artist_login_btn } from '@images/'
import { icon_microphone } from '@images/index'

const ArtistLoginBtn = ({ onClick, style }) => {
  const isKorean =
    (navigator.language || 'en').split('-')[0].toLowerCase() === 'ko'
  return (
    <button
      type="button"
      style={
        {
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '18px',
          justifyContent: 'center',
          borderRadius: '12px',
          background: '#242424',
          padding: '12px',
          width: '220px',
          boxSizing: 'border-box',
          border: 'none',
          ...style,
        }
      }
      onClick={onClick}
    >
      <img
        src={icon_microphone}
        alt="icon_microphone"
        style={
          {
            width: '16px',
            height: '16px',
          }
        }
      />
      <p
        style={
          {
            color: '#fff',
            fontSize: '16px',
            fontWeight: '500',
            lineHeight: '24px',
          }
        }
      >
        {isKorean ? '아티스트로 로그인' : 'Log in with Artist'}
      </p>
    </button>
  )
}

export default ArtistLoginBtn
